// blog data

export const Blogs = [
    {
        id: 1,
        name: "Building a Responsive React Sidebar Component with React Pro Sidebar",
        tags: ["react", "sidebar", "navigation", "react-pro-sidebar", "ui-components"],
        date: "15 July, 2024",
        imgSrc: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://www.npmjs.com/package/react-pro-sidebar"
    },
    {
        id: 2,
        name: "Creating Beautiful Sidebars with Tailwind CSS and Flowbite React",
        tags: ["react", "sidebar", "tailwind", "flowbite", "responsive-design"],
        date: "2 September, 2024",
        imgSrc: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://flowbite-react.com/docs/components/sidebar"
    },
    {
        id: 3,
        name: "Modern React Sidebar Implementation with ShadCN UI Components",
        tags: ["react", "sidebar", "shadcn-ui", "typescript", "modern-ui"],
        date: "28 October, 2024",
        imgSrc: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://ui.shadcn.com/docs/components/sidebar"
    },
    {
        id: 4,
        name: "Building Lightweight React Navigation Components: A Minimalist Approach",
        tags: ["react", "navigation", "lightweight", "components", "navbar"],
        date: "12 December, 2024",
        imgSrc: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://www.syncfusion.com/react-components/react-sidebar"
    },
    {
        id: 5,
        name: "Creating Accessible Modal Components in React with Headless UI",
        tags: ["react", "modal", "accessibility", "headless-ui", "components"],
        date: "8 January, 2025",
        imgSrc: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://headlessui.com/react/dialog"
    },
    {
        id: 6,
        name: "Building Custom Form Components with React Hook Form and Validation",
        tags: ["react", "forms", "validation", "react-hook-form", "components"],
        date: "22 March, 2025",
        imgSrc: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://react-hook-form.com/"
    },
    {
        id: 7,
        name: "Designing Reusable Card Components in React with CSS Modules",
        tags: ["react", "cards", "css-modules", "reusable", "design-system"],
        date: "5 June, 2025",
        imgSrc: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
        link: "https://css-tricks.com/css-modules-part-1-need/"
    }
]
